module.exports = __webpack_public_path__ + "static/media/04.8597bd36.mp3";